import util from './util';
import axios from 'axios';
import signLog from '@/components/sign-log';
import { LOGIN } from '@/store/mutation-types';
import { popMgr } from '../components/global';
import questionnaire from '@/components/questionnaire';
import {
    emitTrack,
    regType,
    state,
    resetRegisStatus,
    setRegisStatus,
    registrationEnum
} from '@/components/sign-log/register-track';
// const HePageKey = [
//     'evaluation',
//     'evaluation-seller',
//     'seller-evaluation',
//     'he-home'
// ];
async function handleCredentialResponse(data, globalData, store) {
    resetRegisStatus();
    setRegisStatus({
        registrationType: registrationEnum.registrationType.chromeApi
    });
    emitTrack(regType.google, state.success);
    const clientId = data.clientId;
    const token = data.credential;
    try {
        const ret = await getUserInfo({
            clientId,
            token,
            ignoreBuyerPhone:
                globalData.registration &&
                globalData.registration.ignoreBuyerPhone
                    ? 1
                    : 0,
            role: globalData.registerUserType
        });
        const { nextStep, registerInfo, user } = ret.data || {};
        if (nextStep === 'third-party-registry') {
            if (window.siteAppVm) {
                signLog.register(
                    {
                        authData: {
                            uid: registerInfo.uid,
                            from: registerInfo.from,
                            email: registerInfo.email,
                            token: registerInfo.token,
                            fullname: registerInfo.fullName || '',
                            firstName: registerInfo.firstName || '',
                            lastName: registerInfo.lastName || '',
                            role: registerInfo.role
                        },
                        showThirdNext: true,
                        isAutoRegister: false,
                        role: registerInfo.role
                    },
                    '',
                    true,
                    true,
                    true
                );
            }
        } else if (
            nextStep === 'third-party-login-completed' ||
            nextStep === 'third-party-registry-completed'
        ) {
            store.commit(LOGIN, { user });
            if (nextStep === 'third-party-registry-completed') {
                emitTrack(regType.register, state.success);
                let inquiry = !!(
                    globalData.questionNaire && globalData.questionNaire.inquiry
                );
                inquiry &&
                    questionnaire.open({
                        globalData: store.state?.page?.page || {}
                    });
            }
        }
    } catch (e) {
        console.error(e);
    }
}

function momentCallback(notification) {
    if (notification.isNotDisplayed() || notification.isSkippedMoment()) {
        console.log(
            'Google One Step Display Moment',
            notification.isNotDisplayed()
        );
        console.log(
            'Google One Step Skipped Moment',
            notification.isSkippedMoment()
        );
    }
}

const getUserInfo = async params =>
    axios.post(`/api-site/third-party/login/googleAutoRegister`, params);

export function initOneStepLogin(globalData, store) {
    setTimeout(() => {
        const googleAppId = globalData.googleAppId;
        const loginStatus = store.state.user.loginStatus;
        // const isMobileSize = store && store.state.common.isMobileSize;
        // if (isMobileSize) return;
        if (loginStatus === 1) return;
        const cur = popMgr.getCurrent();
        if (cur && cur.name === 'sign-log') return;
        if (globalData.registration?.allowOneStepLogin === false) return; // 不能判断undefined,因为存量站是undefined，但是需要该功能
        // HE站
        if (
            globalData.is_evaluation_site &&
            globalData.is_evaluation_site === '1'
            // (globalData.pageKey && HePageKey.includes(globalData.pageKey))
        )
            return;

        if (
            window.sitePrepareData &&
            window.sitePrepareData()._disableChromeAuthority
        ) {
            return;
        }
        util.addScript('https://accounts.google.com/gsi/client', true).then(
            () => {
                let google = window.google;
                google.accounts.id.initialize({
                    client_id: googleAppId,
                    cancel_on_tap_outside: false,
                    callback: data =>
                        handleCredentialResponse(data, globalData, store)
                });
                const curPop = popMgr.getCurrent();
                if (curPop && curPop.name === 'sign-log') return;
                google.accounts.id.prompt(momentCallback);
            }
        );
    }, 5000);
}
